// PowerStateWrapper.js

export default class PowerStateWrapper {
  constructor({
    onSuspend = () => {},
    onResume = () => {},
    onVisible = () => {},
    onHidden = () => {},
  } = {}) {
    this.onSuspend = onSuspend;
    this.onResume = onResume;
    this.onVisible = onVisible;
    this.onHidden = onHidden;

    this._app = null;
    this._visibilityHandler = this._handleVisibilityChange.bind(this);

    this._onPause = () => {
      this.onSuspend();
    };

    this._onResume = () => {
      this.onResume();
    };
  }

  init() {
    // visibilitychange is the primary and most reliable mechanism.
    // It works on all Samsung Tizen versions and in the browser.
    // When the TV goes to standby, document.hidden becomes true.
    document.addEventListener("visibilitychange", this._visibilityHandler);

    // tizen.application.addEventListener is an optional secondary mechanism
    // for older Tizen 4.x firmware that fires onpause/onresume app lifecycle events.
    // On Samsung BU800 / U800 (Tizen 6.x / 7.x) the API validator rejects the
    // callback object with "TypeMismatchError: Cannot convert undefined to function"
    // because it requires a different (firmware-specific) set of callback keys.
    // We therefore attempt it and silently ignore any failure — visibilitychange
    // is sufficient on its own for all known TV models.
    try {
      this._app = tizen.application.getCurrentApplication();

      this._app.addEventListener({
        onpause:   this._onPause,   // Tizen 4.x lifecycle event
        onsuspend: this._onPause,   // some Tizen 6.x builds
        onresume:  this._onResume,
      });
      console.log("PowerStateWrapper: tizen.application.addEventListener registered");

    } catch (e) {
      // Non-fatal: visibilitychange already covers power-state detection.
      // Log only the error name+message (not the Error object itself) to avoid
      // a full stack-trace dump that looks like an unhandled crash in the console.
      console.log(
        "PowerStateWrapper: tizen.application.addEventListener skipped" +
        " [" + e.name + ": " + e.message + "] – using visibilitychange only"
      );
    }
  }

  destroy() {
    document.removeEventListener("visibilitychange", this._visibilityHandler);
    this._app = null;
  }

  _handleVisibilityChange() {
    if (document.hidden) {
      this.onHidden();
    } else {
      this.onVisible();
    }
  }
}



/*
export default class PowerStateWrapper {
  constructor({
    onSuspend = () => {},
    onResume = () => {},
    onVisible = () => {},
    onHidden = () => {},
  } = {}) {
    this.onSuspend = onSuspend;
    this.onResume = onResume;
    this.onVisible = onVisible;
    this.onHidden = onHidden;

    this._app = null;
    this._boundVisibilityHandler = this._handleVisibilityChange.bind(this);
    this._boundPauseHandler = this._handlePause.bind(this);
    this._boundResumeHandler = this._handleResume.bind(this);
  }

  init() {
    // Visibility API (wichtigster Event!)
    document.addEventListener(
      "visibilitychange",
      this._boundVisibilityHandler
    );

    // Application Lifecycle
    try {
      this._app = tizen.application.getCurrentApplication();

      this._app.addEventListener("pause", this._boundPauseHandler);
      this._app.addEventListener("resume", this._boundResumeHandler);
    } catch (e) {
      console.warn("Tizen application API not available", e);
    }
  }

  destroy() {
    document.removeEventListener(
      "visibilitychange",
      this._boundVisibilityHandler
    );

    if (this._app) {
      this._app.removeEventListener("pause", this._boundPauseHandler);
      this._app.removeEventListener("resume", this._boundResumeHandler);
    }
  }

  // *--------------------
  // *Internal handlers
  // * --------------------

  _handleVisibilityChange() {
    if (document.hidden) {
      // TV aus / Standby / HDMI weg
      this.onHidden();
    } else {
      // TV an / Fokus zurück
      this.onVisible();
    }
  }

  _handlePause() {
    // Virtual Standby / Fokusverlust
    this.onSuspend();
  }

  _handleResume() {
    // Power ON / Wake Up
    this.onResume();
  }
}
*/



// WEBPACK FOOTER //
// ./src/helpers/Device/PowerStateWrapper.js